import { render, staticRenderFns } from "./NewBlockButton.vue?vue&type=template&id=03c486a2&scoped=true&"
import script from "./NewBlockButton.vue?vue&type=script&lang=js&"
export * from "./NewBlockButton.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./NewBlockButton.vue?vue&type=style&index=0&id=03c486a2&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "03c486a2",
  null
  ,true
)

export default component.exports